import Navbar from "./Navbar";
import "../../../styles/website/Header.css";

export default function Header() {
  return (
    <header>
      <div className="wrap">
        <Navbar />
      </div>
    </header>
  );
}
